import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { DialogActions, DialogContent, useTheme } from '@mui/material';
import { MarketButton, MarketHeader } from '@market/react';
import { useCheckoutFlow } from 'components/context/checkout_flow';
import { useOrderDetails } from 'components/context/order_details';
import {
  onCheckoutPageClick,
  pushHistoryWithSearchParams,
  CHECKOUT_PAGE_CLICK_EVENTS,
} from 'components/pages/checkout/utilities';

const Declined = () => {
  const theme = useTheme();
  const history = useHistory();
  const { t } = useTranslation();

  const { checkoutClient } = useCheckoutFlow();
  const { trackingData } = useOrderDetails();

  return (
    <>
      <MarketHeader style={{ margin: theme.spacing(4, 4, 0) }}>
        <h1>{t('checkout.financeApp.modals.declined.title')}</h1>
      </MarketHeader>
      <DialogContent sx={{ px: 4, py: 2 }}>
        <p>{t('checkout.financeApp.modals.declined.body')}</p>
      </DialogContent>
      <DialogActions sx={{ px: 4, pb: 4 }}>
        <MarketButton
          id="continue-btn"
          rank="primary"
          // fetching payment options updates order to account for decline
          onClick={() => {
            onCheckoutPageClick({
              eventDesc: CHECKOUT_PAGE_CLICK_EVENTS.financing_declined,
              trackingData,
              componentName: 'Financing Application',
              actionItem: 'continue_to_payment',
            });
            checkoutClient
              .fetchPaymentOptions()
              .then(() => pushHistoryWithSearchParams(history, '/payment'));
          }}
          style={{ width: '100%' }}
        >
          {t('common.continue')}
        </MarketButton>
      </DialogActions>
    </>
  );
};

export default Declined;
